import requests from '../../../../redux/reducer/requests';
import content from '../../../../redux/reducer/content';
import { useDispatch } from 'react-redux';

export default function usePrizeCallbacks() {
  const dispatch = useDispatch();

  return {
    setShowLevelPrizes: (data) => dispatch(content.actions.setShowLevelPrizes(data)),
    buyPrize: (id) => dispatch(requests.thunks.buyPrize(id)),
  };
}
